import iro from '@jaames/iro';
import { debounce } from 'lodash-es';

inputColourDirective.$inject = ['$util'];

export function inputColourDirective($util) {
    return {
        // language=HTML
        template: `
            <div class="app-input-colour-row">

                <md-input-container>
                    <label>{{ label }}</label>

                    <input type="text"
                           name="{{ name || '' }}"
                           ng-attr-tabindex="{{ tabindex }}"
                           ng-click="_showColourPicker()"
                           ng-model="value"
                           ng-disabled="disabled"
                           ng-readonly="readonly"
                           ng-required="required"
                           ng-minlength="minlength"
                           ng-maxlength="maxlength">

                    <div class="hint" ng-show="hint" ng-if="!form[name].$invalid">
                        {{ hint }}
                    </div>

                    <div ng-if="form[name]" ng-messages="form[name].$error">
                        <div ng-message="required">Required</div>
                        <div ng-message="minlength">Must be no less than {{ minlength }}
                            characters
                        </div>
                        <div ng-message="maxlength">Must be no more than {{ maxlength }}
                            characters
                        </div>
                        <div ng-message="custom">{{ form[name].customError }}</div>
                        <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{
                            message }}
                        </div>
                    </div>
                </md-input-container>

                <div class="colour-preview"
                     ng-click="_toggleColourPicker()"
                     ng-style="{ background: value }">
                </div>
            </div>

            <div class="app-input-colour-picker-container" ng-show="ui.colourPickerShowing">
                <div class="app-input-colour-picker"></div>

                <div class="app-input-colour-presets">
                    <div ng-repeat="colour in presetColourOptions"
                         class="colour-preset"
                         ng-click="setColour(colour.value)"
                         ng-style="{ background: colour.value }">

                        <md-tooltip>
                            {{ colour.label }}
                        </md-tooltip>
                    </div>
                </div>
            </div>
        `,
        scope: {
            disabled: '=ngDisabled',
            readonly: '=ngReadonly',
            errorMessages: '=errorMessages',
            form: '=form',
            hint: '@?hint',
            label: '@label',
            minlength: '@?minlength',
            maxlength: '@?maxlength',
            name: '@name',
            required: '=?required',
            tabindex: '@?appTabindex',
            value: '=value',
        },
        link: function(scope, element, attrs) {
            const $el = element[0];
            const $pickerContainer = $el.querySelector('.app-input-colour-picker');

            const ui = (scope.ui = {
                colourPickerShowing: false,
            });

            scope.presetColourOptions = [
                { label: 'Red', value: '#ff0000' },
                { label: 'Maroon', value: '#85144b' },
                { label: 'Purple', value: '#800080' },
                { label: 'Aqua', value: '#7FDBFF' },
                { label: 'Violet', value: '#EE82EE' },
                { label: 'Crimson', value: '#DC143C' },
                { label: 'Blue', value: '#0000ff' },
                { label: 'Lime', value: '#00ff00' },
                { label: 'Pink', value: '#ff1493' },
            ];

            const colourPicker = new iro.ColorPicker($pickerContainer, {
                // Set the size of the color picker UI
                width: 192,
                height: 192,
                // Set the initial color to red
                color: scope.value,
                sliderHeight: 10,
            });

            // Main
            scope.$watch(
                'value',
                value => {
                    if (value && colourPicker.color) {
                        colourPicker.color.set(value);
                    }
                },
                true,
            );

            scope.setColour = value => {
                scope.value = value;
            };

            scope._showColourPicker = () => {
                ui.colourPickerShowing = true;
            };

            scope._toggleColourPicker = () => {
                ui.colourPickerShowing = !ui.colourPickerShowing;
            };

            const _onColourChangedDebounced = debounce(_onColourChange, 50);

            colourPicker.on('color:change', _onColourChangedDebounced);

            scope.$on('$destroy', () => {
                colourPicker.off('color:change', _onColourChangedDebounced);
            });

            function _onColourChange(colour) {
                $util.nextTickImmediate(() => {
                    scope.value = colour.hexString;
                });
            }

            element.addClass('app-form-field');

            // If it's undefined on the scope, it may mean that the attribute is there but
            // without content. If the attribute isn't undefined then we know it's been added.
            if (scope.required === undefined && attrs.required !== undefined) {
                scope.required = true;
            }
        },
    };
}
